import { Color } from 'src/constants';

type Props = {
  /** How far through the day's goal, from 0 to 1. */
  progress: number;
  size: number;
  thickness: number;
  /** Set this to whatever reads as an unfilled ring against the backdrop. */
  trackColor: string;
};

/**
 * The dial showing how much of the day's logging goal has been met.
 */
export default function GoalRing({
  progress,
  size,
  thickness,
  trackColor,
}: Props) {
  const center = size / 2;
  const radius = center - thickness / 2;
  const circumference = 2 * Math.PI * radius;

  return (
    <svg width={size} height={size} style={{ flexShrink: 0 }}>
      <circle
        cx={center}
        cy={center}
        r={radius}
        fill="none"
        stroke={trackColor}
        strokeWidth={thickness}
      />
      <circle
        cx={center}
        cy={center}
        r={radius}
        fill="none"
        stroke={Color.blue}
        strokeWidth={thickness}
        strokeLinecap="round"
        strokeDasharray={circumference}
        strokeDashoffset={circumference * (1 - progress)}
        // Starts the arc at 12 o'clock rather than 3.
        transform={`rotate(-90 ${center} ${center})`}
      />
    </svg>
  );
}
